import ReactToPrint from 'react-to-print';
import PropTypes from 'prop-types';

const ButtonPrint = ({
  buttonName,
  printRef,
  landScape = false,
  disabled = false,
}) => {
  return (
    <>
      {!disabled ? (
        <ReactToPrint
          trigger={() => (
            <button type="button" className="btn xlg tertiary">
              {buttonName}
            </button>
          )}
          content={() => printRef.current}
          removeAfterPrint={true}
          pageStyle={`
    @page {
      size: ${landScape ? 'landscape' : 'portrait'};
      margin: 20mm;
    }
    @media print {
      body {
        padding: 10mm;
      }
      * {
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
      }
      .form-check {
        position: relative;
        display: inline-block;
      }
      .form-check input[type="radio"],
      .form-check input[type="checkbox"] {
        position: relative;
        width: 16px !important;
        height: 16px !important;
        border: 2px solid #000 !important;
        border-radius: 50%;
        background: #fff !important;
        margin-right: 8px;
      }
      .form-check input[type="radio"]:checked,
      .form-check input[type="checkbox"]:checked {
        background: #000 !important;
      }
      .form-check input[type="radio"]:checked:before,
      .form-check input[type="checkbox"]:checked:before {
        content: '';
        position: absolute;
        width: 8px;
        height: 8px;
        background: #fff !important;
        border-radius: 50%;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .tbl-scroll-box {
        overflow: visible !important;
        height: auto !important;
      }
      table { 
        width: 100% !important;
        page-break-inside: avoid;
        border-collapse: collapse;
        table-layout: auto;
      }
      table td, table th {
        padding: 15px !important;
        min-height: 80px !important;
        height: auto !important;
        word-wrap: break-word !important;
        word-break: break-all !important;
        white-space: normal !important;
        vertical-align: middle;
        line-height: 1.5;
      }
      table img {
        max-width: 100%;
        height: auto;
      }
      ::-webkit-scrollbar {
        display: none !important;
      }
    }
  `}
        />
      ) : (
        <button type="button" className="btn xlg tertiary" disabled>
          인쇄
        </button>
      )}
    </>
  );
};

ButtonPrint.propTypes = {
  buttonName: PropTypes.string.isRequired,
  printRef: PropTypes.object.isRequired,
};

export default ButtonPrint;
